import {Link} from "react-router-dom";

import Simulators from "../components/Simulators.jsx";

const STEPS = [
    {
        title: "Create an account",
        description: "Create an account or sign in.",
        actions: [{label: "Sign in", to: "/login"}]
    },
    {
        title: "Create an API key",
        description: "Generate an API key to authenticate your requests. Keep it secret, it grants access to your account.",
        actions: [{label: "API keys", to: "/keys"}]
    },
    {
        title: "Submit jobs",
        description: "Install the Python client with pip install qcloud-client, or call the REST API from any language.",
        actions: [{label: "Documentation", to: "/docs"}]
    }
];

export default function Home() {
    return (
        <div className="main">
            <section>
                <h1>Welcome to DTU QCloud</h1>

                <p>
                    DTU QCloud is a cloud-based interface developed by DTU Physics' Quantum Physics and Information Technology (QPIT) sector that enables researchers and organizations to run quantum computing algorithms and experiments remotely.
                    The platform can be used through the <Link to="/docs#python">Python package</Link> or accessed from any language via the <Link to="/docs#api">REST API</Link>.
                    Current support includes tensor network sampling and remote interaction with equipment found in DTU Physics laboratories.
                </p>
            </section>
            <section>
                <h2>Simulators</h2>
                <Simulators/>
            </section>
            <section>
                <h2>Get started</h2>
                {STEPS.map((step, i) => (
                    <div className="card" key={step.title}>
                        <div className="start">
                            <div className="card-head">
                                <span className="title">{i + 1}. {step.title}</span>
                            </div>
                            <p className="meta-row">{step.description}</p>
                        </div>
                        <div className="end step-actions">
                            {step.actions.map(action => (
                                <Link key={action.to} to={action.to} className="button" tabIndex={0}>{action.label}</Link>
                            ))}
                        </div>
                    </div>
                ))}
            </section>
        </div>
    );
};
